import Swiper from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
	new Swiper('.sectionImagebanner__swiper', {
		effect: 'fade',
		autoplay: { // If this parameter is not specified, auto play will be disabled.
			// In this case, the delay option is controlled by data-swiper-autoplay attribute.
		},
	});
});
